var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 63,
    viewBox: "0 0 60 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7225 34.5958C14.9576 29.2873 14.9174 20.4092 15.033 16.7681C15.0625 15.8372 15.8133 15.1068 16.7427 15.0452C18.3287 14.9402 20.7545 14.7301 22.5551 14.351C24.7888 13.8808 27.9845 12.7454 29.3457 12.2445C29.7692 12.0887 30.2308 12.0887 30.6542 12.2445C32.0154 12.7454 35.2112 13.8808 37.4449 14.351C39.2455 14.7301 41.6713 14.9402 43.2573 15.0452C44.1867 15.1068 44.9375 15.8372 44.967 16.7681C45.0825 20.4092 45.0424 29.2873 42.2775 34.5958C39.7842 39.383 33.4809 44.3283 31.013 46.1467C30.4052 46.5945 29.5947 46.5945 28.987 46.1467C26.5191 44.3283 20.2158 39.383 17.7225 34.5958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7225 34.5958C14.9576 29.2873 14.9174 20.4092 15.033 16.7681C15.0625 15.8372 15.8133 15.1068 16.7427 15.0452C18.3287 14.9402 20.7545 14.7301 22.5551 14.351C24.7888 13.8808 27.9845 12.7454 29.3457 12.2445C29.7692 12.0887 30.2308 12.0887 30.6542 12.2445C32.0154 12.7454 35.2112 13.8808 37.4449 14.351C39.2455 14.7301 41.6713 14.9402 43.2573 15.0452C44.1867 15.1068 44.9375 15.8372 44.967 16.7681C45.0825 20.4092 45.0424 29.2873 42.2775 34.5958C39.7842 39.383 33.4809 44.3283 31.013 46.1467C30.4052 46.5945 29.5947 46.5945 28.987 46.1467C26.5191 44.3283 20.2158 39.383 17.7225 34.5958Z",
    stroke: "white",
    strokeWidth: 0.130612
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3234 24.095C36.7109 22.9022 35.5689 22.0708 34.2458 21.8542C32.9226 21.6376 31.5751 22.0615 30.6143 22.9967L30.0658 23.4983L29.5347 23.0147C28.5756 22.0609 27.2151 21.6289 25.8815 21.8548C24.5556 22.0615 23.4111 22.8955 22.8083 24.0943C21.9932 25.6917 22.3077 27.6331 23.5854 28.8914L29.6053 35.093C29.7262 35.2174 29.8923 35.2876 30.0658 35.2876C30.2393 35.2876 30.4054 35.2174 30.5263 35.093L36.5379 28.9029C37.8209 27.6434 38.1388 25.6973 37.3234 24.095Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3234 24.095C36.7109 22.9022 35.5689 22.0708 34.2458 21.8542C32.9226 21.6376 31.5751 22.0615 30.6143 22.9967L30.0658 23.4983L29.5347 23.0147C28.5756 22.0609 27.2151 21.6289 25.8815 21.8548C24.5556 22.0615 23.4111 22.8955 22.8083 24.0943C21.9932 25.6917 22.3077 27.6331 23.5854 28.8914L29.6053 35.093C29.7262 35.2174 29.8923 35.2876 30.0658 35.2876C30.2393 35.2876 30.4054 35.2174 30.5263 35.093L36.5379 28.9029C37.8209 27.6434 38.1388 25.6973 37.3234 24.095Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3234 24.095C36.7109 22.9022 35.5689 22.0708 34.2458 21.8542C32.9226 21.6376 31.5751 22.0615 30.6143 22.9967L30.0658 23.4983L29.5347 23.0147C28.5756 22.0609 27.2151 21.6289 25.8815 21.8548C24.5556 22.0615 23.4111 22.8955 22.8083 24.0943C21.9932 25.6917 22.3077 27.6331 23.5854 28.8914L29.6053 35.093C29.7262 35.2174 29.8923 35.2876 30.0658 35.2876C30.2393 35.2876 30.4054 35.2174 30.5263 35.093L36.5379 28.9029C37.8209 27.6434 38.1388 25.6973 37.3234 24.095Z",
    fill: "url(#paint2_radial)",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.9671 16.768C45.0826 20.4091 45.0424 29.2873 42.2776 34.5958C39.9596 39.0463 34.3484 43.6336 31.5878 45.7179C31.2551 45.969 30.9779 46.1723 30.7388 46.2855C30.2809 46.5024 30.0001 46.4814 30.0001 46.4814V45.7957V44.7182V12.3918V12.1426C30.0001 12.1426 30.4387 12.168 31.1306 12.4181C31.8139 12.6651 32.7442 12.9919 33.7429 13.3158C34.9855 13.7188 36.3342 14.1171 37.4449 14.3509C39.2455 14.73 41.6714 14.9401 43.2574 15.0452C44.1867 15.1067 44.9375 15.8371 44.9671 16.768Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.934692,
    y: 0.0623169,
    width: 58.1306,
    height: 62.4856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 5.35901,
    y: 8.7959,
    width: 49.4125,
    height: 47.4917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.0653,
    y1: 21.7959,
    x2: 30.0653,
    y2: 35.2876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 22.359,
    y1: 28.5417,
    x2: 37.7717,
    y2: 28.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D7ED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D7ED4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6003 28.5418) rotate(88.5192) scale(6.62685 38.0252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164A6D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d2fe1168c8cc17ded31e69970500e46a.svg";
export { ForwardRef as ReactComponent };